module.exports = __webpack_public_path__ + "img/image_35.21cc2db6.png";